<section class="statistiques-view" *ngIf="statistiques$ | async as statistiques">
  <div class="statistiques-toolbar">
    <div>
      <h2>Statistiques projets</h2>
      <p>{{ statistiques.nombreSimulationsAvecValidationEngagement || 0 }} simulations avec validation engagement</p>
    </div>
    <div class="statistiques-actions">
      <button type="button" class="btn filter-toggle" [class.active]="filterPanelOpen" (click)="toggleFilterPanel()">
        Filtrer
      </button>
      <div class="chart-mode-toggle" role="group" aria-label="Type de graphique">
        <button type="button" class="btn" [class.active]="chartMode === 'bar'" (click)="setChartMode('bar')">
          Barres
        </button>
        <button type="button" class="btn" [class.active]="chartMode === 'pie'" (click)="setChartMode('pie')">
          Camembert
        </button>
      </div>
    </div>
  </div>

  <div class="statistiques-filters" *ngIf="filterPanelOpen">
    <label>
      Utilisateur
      <select class="form-select" [(ngModel)]="selectedUserId">
        <option [ngValue]="null">Tous les utilisateurs</option>
        <option *ngFor="let utilisateur of utilisateurs$ | async" [ngValue]="utilisateur.id">
          {{ utilisateur.prenom }} {{ utilisateur.nom }}
        </option>
      </select>
    </label>

    <label>
      Date début
      <input type="date" class="form-control" [(ngModel)]="dateDebut">
    </label>

    <label>
      Date fin
      <input type="date" class="form-control" [(ngModel)]="dateFin">
    </label>

    <ng-container *ngIf="filtresDisponibles$ | async as filtres">
      <label>
        Tranche de puissance
        <select class="form-select" [(ngModel)]="selectedTranchePuissance">
          <option value="">Toutes les tranches</option>
          <option *ngFor="let tranche of filtres.tranchesPuissance" [value]="tranche.code">{{ tranche.label }}</option>
        </select>
      </label>

      <label>
        Région
        <select class="form-select" [(ngModel)]="selectedRegion">
          <option value="">Toutes les régions</option>
          <option *ngFor="let region of filtres.regions" [value]="region">{{ region }}</option>
        </select>
      </label>

      <label>
        Typologie
        <select class="form-select" [(ngModel)]="selectedTypologie">
          <option value="">Toutes les typologies</option>
          <option *ngFor="let typologie of filtres.typologies" [value]="typologie.code">{{ typologie.label }}</option>
        </select>
      </label>

      <label>
        Mode de valorisation
        <select class="form-select" [(ngModel)]="selectedModeValorisation">
          <option value="">Tous les modes</option>
          <option *ngFor="let mode of filtres.modesValorisation" [value]="mode.code">{{ mode.label }}</option>
        </select>
      </label>

      <label>
        Livrable
        <select class="form-select" [(ngModel)]="selectedLivrable">
          <option value="">Tous les livrables</option>
          <option *ngFor="let livrable of filtres.livrables" [value]="livrable.code">{{ livrable.label }}</option>
        </select>
      </label>
    </ng-container>

    <div class="filter-buttons">
      <button type="button" class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
      <button type="button" class="btn btn-outline-secondary" (click)="resetFilters()">Réinitialiser</button>
    </div>
  </div>

  <div class="statistiques-grid">
    <article class="statistique-panel" *ngFor="let section of buildSections(statistiques)">
      <header>
        <h3>{{ section.title }}</h3>
        <span>{{ getTotal(section.items) }} projets</span>
      </header>

      <div class="empty-state" *ngIf="getTotal(section.items) === 0">Aucune donnée</div>

      <div class="bar-chart" *ngIf="chartMode === 'bar' && getTotal(section.items) > 0">
        <div class="bar-row" *ngFor="let item of section.items">
          <div class="bar-label">{{ item.label }}</div>
          <div class="bar-track">
            <div class="bar-fill" [style.width.%]="getBarWidth(item, section.items)" [style.background-color]="item.color"></div>
          </div>
          <div class="bar-value">{{ item.value }}</div>
        </div>
      </div>

      <div class="pie-chart-layout" *ngIf="chartMode === 'pie' && getTotal(section.items) > 0">
        <div class="pie-chart" [style.background]="getPieGradient(section.items)">
          <div class="pie-center">{{ getTotal(section.items) }}</div>
        </div>
        <div class="pie-legend">
          <div class="legend-row" *ngFor="let item of section.items">
            <span class="legend-color" [style.background-color]="item.color"></span>
            <span class="legend-label">{{ item.label }}</span>
            <span class="legend-value">{{ item.value }} · {{ getPercent(item, section.items) }}%</span>
          </div>
        </div>
      </div>
    </article>
  </div>
</section>
